"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.isOptimetriksRole = exports.OPTIMETRIKS_ROLES = void 0;
exports.getOptimetriksAccessRightProfiles = getOptimetriksAccessRightProfiles;
const types_1 = require("../types");
const actions_1 = require("./actions");
const lodash_1 = __importDefault(require("lodash"));
var OPTIMETRIKS_ROLES;
(function (OPTIMETRIKS_ROLES) {
    OPTIMETRIKS_ROLES["SUPERADMIN"] = "superadmin";
    OPTIMETRIKS_ROLES["ADMIN"] = "optimetriks_admin";
    OPTIMETRIKS_ROLES["OPERATION"] = "optimetriks_operations";
})(OPTIMETRIKS_ROLES || (exports.OPTIMETRIKS_ROLES = OPTIMETRIKS_ROLES = {}));
const isOptimetriksRole = (role) => {
    return Object.values(OPTIMETRIKS_ROLES).includes(role);
};
exports.isOptimetriksRole = isOptimetriksRole;
const authorizedAllBulkAction = () => {
    const action = {};
    const objectCategoriesKeys = lodash_1.default.keys(types_1.OBJECT_CATEGORY);
    lodash_1.default.each(objectCategoriesKeys, (key) => {
        action[`BULK_ACTIONS_${key}S`] = true;
    });
    return action;
};
function getOptimetriksAccessRightProfiles() {
    const superAdminAccessRight = actions_1.ACTIONS_WITH_AUTH_CHECK.reduce((a, b) => (Object.assign(Object.assign({}, a), { [b]: true })), {});
    return [
        {
            name: OPTIMETRIKS_ROLES.SUPERADMIN,
            access_all_resources: true,
            actions: Object.assign(Object.assign({}, superAdminAccessRight), authorizedAllBulkAction()),
        },
        {
            name: OPTIMETRIKS_ROLES.ADMIN,
            access_all_resources: true,
            actions: Object.assign(Object.assign(Object.assign({}, superAdminAccessRight), authorizedAllBulkAction()), { [types_1.ACTION_CODE.DELETE_CLIENT]: false }),
        },
        {
            name: OPTIMETRIKS_ROLES.OPERATION,
            access_all_resources: true,
            actions: Object.assign(Object.assign(Object.assign({}, superAdminAccessRight), authorizedAllBulkAction()), { [types_1.ACTION_CODE.DELETE_CLIENT]: false, [types_1.ACTION_CODE.DELETE_WORKFLOW]: false, [types_1.ACTION_CODE.DELETE_LIST]: false }),
        },
    ];
}
